import { useEffect, useRef, useState } from "react";

import { Input } from "antd";

const DEBOUNCE_TIME = 350;

interface TSTTextFilterInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export function TSTTextFilterInput({
    value,
    onChange,
    placeholder,
}: TSTTextFilterInputProps) {
    const [draft, setDraft] = useState(value);
    const [prevValue, setPrevValue] = useState(value);
    const debounceTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(
        undefined
    );

    if (prevValue !== value) {
        setPrevValue(value);
        setDraft(value);
    }

    useEffect(() => () => clearTimeout(debounceTimeout.current), []);

    const handleChange = (next: string) => {
        setDraft(next);
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(
            () => onChange(next),
            DEBOUNCE_TIME
        );
    };

    return (
        <Input
            value={draft}
            placeholder={placeholder}
            allowClear
            onChange={(e) => handleChange(e.target.value)}
        />
    );
}
